module.exports = __webpack_public_path__ + "static/img/998-20195764_GMA-US1.3b3bc9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/998-20195764_GMA-US1.jpg
// module id = +eK2
// module chunks = 0